module.exports = __webpack_public_path__ + "static/media/financial-services-landscape.97dbf0fa.jpg";